<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<button
  type="button"
  role="checkbox"
  class="ngf-checkbox__btn"
  [disabled]="disabled$ | async"
  [attr.aria-checked]="indeterminate ? 'mixed' : (checked ? 'true' : 'false')"
  [attr.aria-disabled]="disabled$ | async"
  [attr.aria-label]="ariaLabelTxt"
  [attr.aria-describedby]="ariaDescribedby"
  [attr.aria-required]="ariaRequired ? 'true' : null"
  [attr.aria-invalid]="ariaInvalid ? 'true' : null"
  (click)="toggle($event)"
  (keydown.space)="toggle($event)" tabindex="0"
>
  <div class="ngf-checkbox__box" [class.ngf-checkbox__checked]="checked || indeterminate">
    @if(checked || indeterminate) {
    <mat-icon class="ngf-checkbox__icon">
      {{ indeterminate ? 'horizontal_rule' : 'check' }}
    </mat-icon>
    }
  </div>

  <span class="ngf-checkbox__label" #ref [hidden]="ref.textContent | emptyCheck">
    <ng-content></ng-content>
  </span>
</button>
